module.exports = __webpack_public_path__ + "img/034-china.52582e4d.svg";